import Subscription from '../../../settings/components/Subscription';

const SubscriptionPage = () => {
    return <Subscription />;
};

export default SubscriptionPage;
